"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOrgnr = exports.OrgnrCodec = void 0;
const t = __importStar(require("io-ts"));
const E = __importStar(require("fp-ts/Either"));
const validator_1 = __importDefault(require("validator"));
const function_1 = require("fp-ts/function");
const validation_1 = require("@bloodline-packages/bloodline/dist/validation");
exports.OrgnrCodec = t.brand(t.string, (v) => t.string.is(v) && validator_1.default.isISO31661Alpha2(v.slice(0, 2)), 'Orgnr');
const parseOrgnr = (orgnr) => (0, function_1.pipe)(orgnr, exports.OrgnrCodec.decode, E.mapLeft((0, validation_1.toValidationError)('Could not parse orgnr', orgnr)));
exports.parseOrgnr = parseOrgnr;
//# sourceMappingURL=orgnr.js.map